import { BreadCrumbs } from '@app/components/BreadCrumbs';
import { Layout } from '@app/components/Layout';
import { LectureListView } from './LectureListView';

export function MeetYourProfessors() {
  return (
    <Layout>
      <BreadCrumbs
        links={[
          {
            label: 'Student Portal',
            link: '/',
          },
          {
            label: 'Meet Your Professors',
            link: '/professors',
          },
        ]}
      />
      <LectureListView />
    </Layout>
  );
}
